// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import "firebase/auth";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCCWZQDfE8YdMUlKv7pcpu8P7tolWZhAi0",
  authDomain: "software-sales-portal.firebaseapp.com",
  projectId: "software-sales-portal",
  storageBucket: "software-sales-portal.appspot.com",
  messagingSenderId: "403275837830",
  appId: "1:403275837830:web:b7a9ba8de058cbbd673c07",
  measurementId: "G-X3R4H8SRP6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Export firestore database
// It will be imported into your react app whenever it is needed
export const db = getFirestore(app);

export const auth = getAuth();